import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { environment } from '@shared-envs';

interface FollowingUser {
  userId: number;
  nickname: string;
  icon?: string;
  firstName?: string;
  lastName?: string;
}

@Component({
  selector: 'ark-lib-add-founder-modal',
  templateUrl: './add-founder-modal.component.html',
  styleUrls: ['./add-founder-modal.component.css'],
})
export class AddFounderModalComponent implements OnInit {
  @Input() existingFounders: FollowingUser[] = [];
  @Input() allFollowing: FollowingUser[] = [];

  availableFounders: FollowingUser[] = [];
  selectedFounders: FollowingUser[] = [];

  private searchSubject = new Subject<string>();
  loading = true;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    environment.log('ngOnInit - allFollowing:', this.allFollowing);
    environment.log('ngOnInit - existingFounders:', this.existingFounders);

    this.selectedFounders = [...this.existingFounders];

    this.updateAvailableFounders();

    this.loading = false;

    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((query) => this.updateAvailableFounders(query));
  }

  private updateAvailableFounders(query: string = '') {
    const normalized = query.toLowerCase().trim();

    this.availableFounders = this.allFollowing
      // exclude already selected
      .filter((u) => !this.selectedFounders.find((c) => c.userId === u.userId))
      // apply search if query exists
      .filter((u) => {
        if (!normalized) return true;
        const fullName =
          `${u.firstName ?? ''} ${u.lastName ?? ''}`.toLowerCase();
        const nickname = u.nickname ? u.nickname.toLowerCase() : '';
        return fullName.includes(normalized) || nickname.includes(normalized);
      });
  }

  onSearchChange(value: string | null | undefined) {
    this.searchSubject.next(value ?? '');
  }

  onFounderSelect(user: FollowingUser) {
    if (!this.selectedFounders.find((c) => c.userId === user.userId)) {
      this.selectedFounders.push(user);
      this.updateAvailableFounders();
    }
  }

  removeSelectedFounder(founder: FollowingUser) {
    this.selectedFounders = this.selectedFounders.filter(
      (c) => c.userId !== founder.userId,
    );
    this.updateAvailableFounders();
  }

  finalizeSelection() {
    this.modalCtrl.dismiss(this.selectedFounders);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
}
